import { useCallback } from "react";

/**
 * useTruncate - Custom hook to truncate strings
 * @param {number} maxLength - Maximum allowed length of the string
 * @param {boolean} [withEllipsis=true] - Whether to append '...' at the end
 * @returns {function} - A function to truncate a string
 */
const useTruncate = (maxLength, withEllipsis = true) => {
  return useCallback((text = "") => {
    if (typeof text !== "string") return "";
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + (withEllipsis ? "..." : "");
  }, [maxLength, withEllipsis]);
};

export default useTruncate;
